import { publicClient } from './apiClients'
import {
  Appointment,
  Booking,
  BookingV2,
  CreateAppointmentForExistingPatientPayload,
  GapFillerResponse,
  ExistingPatientBooking,
  ExistingPatientBookingResponse,
  NewPatientBookingResponse,
} from '@customTypes/Booking'
import { GapFillerBooking } from '@customTypes/Booking'
import { QueryParams } from '@customTypes/Generic'
import { getAppointmentFromBookingData, getRecallBookingFromBookingData } from './mappers'
import { RecallQueryParams } from '@customTypes/Recall'
import { AxiosResponse } from 'axios'

export const createRecallBooking = async (bookingData: Booking) => {
  const appointment = getRecallBookingFromBookingData(bookingData)
  return postAppointmentForExistingPatient(appointment, bookingData.trackingParams, bookingData.lang)
}

export const postAppointmentForExistingPatient = async (
  existingPatientBooking: ExistingPatientBooking,
  trackingParams: RecallQueryParams | undefined,
  lang: string
): Promise<AxiosResponse<ExistingPatientBookingResponse>> => {
  return publicClient.post('/appointment-bundles/with-reference', existingPatientBooking, {
    params: { ...trackingParams, lang },
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const createBookingForNewPatient = async (bookingData: BookingV2) => {
  const appointment = getAppointmentFromBookingData(bookingData)
  return postAppointmentForNewPatient(appointment, bookingData.trackingParams, bookingData.lang)
}

export const postAppointmentForNewPatient = async (
  appointment: Appointment,
  trackingParams: QueryParams | undefined,
  lang: string
): Promise<AxiosResponse<NewPatientBookingResponse>> => {
  return publicClient.post('/appointment-bundles', appointment, {
    params: { ...trackingParams, lang },
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const createAppointmentForExistingPatient = async (data: CreateAppointmentForExistingPatientPayload) => {
  return postAppointmentForExistingPatient(
    {
      clinicReferenceId: data.clinicReferenceId,
      employeeReferenceId: data.employeeReferenceId,
      patientReferenceId: data.patientReferenceId,
      start: data.start,
      treatmentBundleReferenceId: data.treatmentBundleReferenceId,
      dataPrivacyAccepted: true,
      creationSource: data.creationSource,
      creationEvent: data.creationEvent,
      additionalAppointmentHints: data.additionalAppointmentHints,
    },
    data.trackingParams,
    data.lang
  )
}

export const postGapFillerBooking = async (
  bookingData: GapFillerBooking
): Promise<AxiosResponse<GapFillerResponse>> => {
  const { appointmentBundleReferenceId, start, trackingParams, practitionerId, creationSource, creationEvent } =
    bookingData

  return publicClient.post(
    `/appointment-bundles/${appointmentBundleReferenceId}/reschedule`,
    {
      start,
      creationSource,
      creationEvent,
    },
    {
      params: {
        ...trackingParams,
        practitionerReferenceIds: practitionerId || trackingParams?.practitionerReferenceIds?.join(','),
      },
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )
}
